import { render, staticRenderFns } from "./ads-postpaid-payment-success.vue?vue&type=template&id=98d4de68&scoped=true"
import script from "./ads-postpaid-payment-success.vue?vue&type=script&lang=js"
export * from "./ads-postpaid-payment-success.vue?vue&type=script&lang=js"
import style0 from "./ads-postpaid-payment-success.vue?vue&type=style&index=0&id=98d4de68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d4de68",
  null
  
)

export default component.exports